var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('re-button',{attrs:{"type":_vm.type},on:{"click":_vm.copyFunction}},[_vm._v(_vm._s(_vm.text)+"\n  "),_c('textarea',{staticClass:"clipFakeInput",attrs:{"id":"clipFakeInput"}},[_vm._v("这是幕后黑手")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9328afe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/remo-clipboard/src/remo-clipboard.vue
// module id = null
// module chunks = 